var VanityLookup = {
  // Demos
  "Shuffled-Demo-Single-Deck": "1N5eeyKTVWo5QeGcUV_zYtwtR0DikJCcvcj6w69UkC1w",
  "Shuffled-Demo-Multi-Deck": "1N2N8URSswhmxLalPOkzi5d4kdeFiGrsobEmM_ojk0ow",
  "Timed-Demo": "1yq2AKwaYL1uZrCnEfwgSpC0SPkQAZqnCdjNxH_pm018",
  "Monster-Demo": "1NgNHy7Qe1R8KhGR2cOmJwL2aOl2tocBemW2HIAKjrvI",
  "Slot-Machine-Demo": "1t5LRUQG9DzMJ3kd8E9DZV7_EbE8J5-Gqhz7TWQ4Y-uU",
  "Phases-Demo": "1HataDfV2lrA4hfzmLgDjXH09dEMLQV6OT10tVH9G52A",
  "Secret-Cards-Demo": "1JwMF02DSxNKtjHp6u-wyznSs-iEG_3DpOobgc17I16o",

  // Games
  "Compersion": "1XVd4Kgq3X3utOm25JXOsDbhI_jLjAHX8mGzpiT6Sgho",
  "Cute-Games-For-First-Dates": "1jaGlSVeBBCfRvY5j_lLrz5YC_psGOVURn_OaXbr2JH0",
  "Reunion": "1rJ3L8E_sBEqiRO8ADQeSAS2UmcK9Xzk0g_F0d_XkkRc",
  "This-Heart-Within-Me-Burns": "1WLy_IM9DehQbrBNjTdL67Bc-ZiW83INcfxlnzpDMqnA",
  "A-Plague-Among-Us": "1PCrllhqjllGM4PAEZz7msxQveTVBRDw4cfH2QjJPss0",
  "Prom-Queen": "1jnrm_6xwsNC-as1zxEc05vQiNmKQBwFPLQfElZ4dfXs",
  "Ring": "1FiJNWdGtIanR4yDSDU545wGZKiFoxP2FeD_KfDcSG18",
  "Through-All-These-Years": "1LuWobaoO92Z4mDbwiY2M5f_lQ1T_Uj12I70jRJ2rZaE",
  "The-Wizards-Tower": "1XFyNmVDbuNyJyl1KP6nyPvesAckFXQ6hGAQDKOBF7Y0",
  "For-the-Heir": "1ABMp5mNdv5wMRFe9oDtoM8Hx0MdHVL2_iuSaqsRHaag",
  "For-the-Heir-One-Act": "1Qb0MM3pwjZZtFX8jyZnk5arH4pbPctOLx3e3qhPh5GA",
  "Mirror-Bound": "1yBtJ8X8eDixJfLVzjyaaUxj7vVToOVbxMeEeB1HSPcM",
  "Iseguy": "1O6w2eLaRygC6wq5grOJfyx_fWkP3WhCKeaSMtTC5-Oc",
  "Many-Patterns": "1iUg8mmZFSltJvlelsexRwxG8xxBGC04FLH5cmHCCPog",
  "Bloom-Brink": "19w2se79WgpFXwzGbZn0E_puHa2BncbOt4NtcmJvf7dQ",
  "Deck-of-Many-Ideas": "1yXf1nJ1KqHuBju9mmyRY2Fw_Rrs1OioBSzNg3hXQ46I",
  "Last-Summer": "1FFJ2_UJFGOX5mpUIfxr6aQNolRvcu7uv33s9nz1AQoc",
  "Rusting-Giant": "1Zd8_IKbXzxWMYi-t25Tz4Q3Q13P20dF-RjnDPSU-JwQ",
  "Our-Ties-Forever-Bound": "1sTJiVc3T7vzfkTIsbgybl3kQ1sFZHu1Pk_KV6wZGPog",
  "Kaiju-Haiku": "1V5foCiEOIFM-MT2aewLvjhpUH25_iD6_JWgfBldidfc",
  "Empathy-is-Cyberpunk": "1b320bxNguUTtVs4f731y7wFX_tOBtNEJyJyGwt8eN6w",
  "End-of-the-Line": "1Hugmc0cZIFJemNLLtMEDBDnHMQxOumVS8PoHM8YvnM0"




}

export default VanityLookup